"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTracker = exports.initAllTrackers = exports.TrackerUSDManager = exports.TrackerAuthenticator = exports.TrackerAPI = exports.trackers = exports.tracker = void 0;
const web_ui_features_1 = require("@gruposantander/web-ui-features");
exports.tracker = {
    track: () => {
        throw new Error('should execute initTracker before call track');
    },
};
exports.trackers = {
    tealiumTracker: null,
    wrapupTracker: null,
    domEventsTracker: null,
};
const initAllTrackers = async (config, API, manager, authenticator) => {
    const trackersToInitialize = [];
    exports.TrackerUSDManager = manager;
    exports.TrackerAPI = API;
    exports.TrackerAuthenticator = authenticator;
    // DomEventsTracker
    if (config.domEventsTracker) {
        const domEventsTrackers = config.domEventsTracker.configDataKeyFormatter
            ? new web_ui_features_1.DomEventsTracker(config.domEventsTracker.configData, config.domEventsTracker.configDataKeyFormatter)
            : new web_ui_features_1.DomEventsTracker(config.domEventsTracker.configData);
        trackersToInitialize.push(domEventsTrackers);
        exports.trackers.domEventsTracker = domEventsTrackers;
    }
    // TealiumTracker
    if (config.tealiumTracker) {
        const tealiumTracker = config.tealiumTracker.configDataKeyFormatter
            ? new web_ui_features_1.TealiumTracker(config.tealiumTracker.configData, config.tealiumTracker.configDataKeyFormatter)
            : new web_ui_features_1.TealiumTracker(config.tealiumTracker.configData);
        trackersToInitialize.push(tealiumTracker);
        exports.trackers.tealiumTracker = tealiumTracker;
    }
    // WrapupTracker
    if (config.wrapupTracker) {
        const wrapupTracker = new web_ui_features_1.WrapupTracker(config.wrapupTracker.configData, exports.TrackerUSDManager.getMethods().registerTrace);
        trackersToInitialize.push(wrapupTracker);
        exports.trackers.wrapupTracker = wrapupTracker;
    }
    const trackerManager = new web_ui_features_1.TrackerManager(trackersToInitialize);
    // trackers and tracker help to not expose internal interface
    exports.tracker.track = (action, data) => {
        trackerManager.track(action, data);
    };
};
exports.initAllTrackers = initAllTrackers;
const initTracker = async (config) => {
    const trackersToInitialize = [];
    // TealiumTracker
    if (config.tealiumTracker) {
        const tealiumTracker = new web_ui_features_1.TealiumTracker(config.tealiumTracker.configData);
        trackersToInitialize.push(tealiumTracker);
        exports.trackers.tealiumTracker = tealiumTracker;
    }
    const trackerManager = new web_ui_features_1.TrackerManager(trackersToInitialize);
    // trackers and tracker help to not expose internal interface
    exports.tracker.track = (action, data) => {
        trackerManager.track(action, data);
    };
};
exports.initTracker = initTracker;
//# sourceMappingURL=tracker.js.map